import React from 'react';
import { usePrototype } from '../../contexts/PrototypeContext';
import { productImages, siteConfig } from '../../data/siteConfig';
import { useAnchorNavigation } from '../../hooks/useAnchorNavigation';
import { buttonClasses } from '../../utils/buttonStyles';
import { ProductOffer } from '../ui/ProductOffer';
export function Hero() {
  const {
    seasonConfig
  } = usePrototype();
  const goTo = useAnchorNavigation();
  const {
    product,
    fulfillment
  } = siteConfig;
  const isDark = seasonConfig.id === 'black-friday';
  const titleColor = isDark ? 'text-canvas' : 'text-ink';
  const bodyColor = isDark ? 'text-canvas/80' : 'text-ink-muted';
  const eyebrowColor = isDark ? 'text-champagne' : seasonConfig.accentTextClass;
  const ruleColor = isDark ? 'bg-champagne' : seasonConfig.accentRuleClass;
  return <section data-hero-panel={seasonConfig.id} aria-labelledby="hero-title" className={`overflow-hidden transition-colors duration-200 ease-out ${seasonConfig.heroPanelClass}`} data-id="element-185" data-mp="1v3c3opm4wpcb">
      <div className="mx-auto grid max-w-page items-center gap-5 px-5 pb-8 pt-7 md:grid-cols-[1.04fr_0.96fr] md:gap-6 md:px-10 md:py-14 lg:min-h-[630px] lg:gap-14 lg:py-16" data-id="element-186" data-mp="1mvayc08qgkfd">
      <div className="relative z-10 min-w-0 max-w-xl" data-id="element-187" data-mp="1cyeqzxukm4ce">
        <div className="flex items-center gap-3" data-id="element-188" data-mp="1czzifell9761">
          <span aria-hidden="true" className={`h-px w-10 shrink-0 transition-colors duration-200 ${ruleColor}`} data-id="element-189" data-mp="1hwq189os2gv5" />
          <p className={`min-w-0 text-[14px] font-medium [overflow-wrap:anywhere] transition-colors duration-200 ${eyebrowColor}`} data-id="element-190" data-mp="25nvcscnoqmzn">
            {seasonConfig.heroEyebrow}
          </p>
        </div>
        <h1 id="hero-title" className={`mt-4 font-display text-[42px] font-medium leading-[1.02] tracking-[-0.01em] md:mt-5 md:text-[54px] lg:text-[72px] ${titleColor}`} data-id="element-191" data-mp="1vvzf32pigyvy">
          Your Skincare Ritual, Powered By Laser.
        </h1>
        <p className={`mt-4 max-w-lg text-[16px] leading-relaxed md:mt-5 md:text-[17px] lg:text-[18px] ${bodyColor}`} data-id="element-192" data-mp="2tcem8vih15tb">
          A laser facial mask for men and women, with a soft, flexible fit, a handheld controller and optional voice control.
        </p>
        <div className="mt-6 flex flex-col flex-wrap gap-3 sm:flex-row md:mt-7" data-id="element-193" data-mp="2y9tpd5auje5s">
          <a href="/#the-mask" onClick={goTo('the-mask')} className={buttonClasses(isDark ? 'inverse' : 'primary')} data-id="element-194" data-mp="2u6npqgi8ol8a">
            Shop the mask
          </a>
          <a href="/#details" onClick={goTo('details')} className={buttonClasses(isDark ? 'inverse-outline' : 'secondary')} data-id="element-195" data-mp="2k9j026p6q7mq">
            Explore the details
          </a>
        </div>
        <div className="mt-4 md:mt-6" data-id="element-196" data-mp="2fgzlp7iob8gv">
          <ProductOffer inverse={isDark} data-id="element-197" data-mp="2aiy3spwzhf6z" />
          <p className={`mt-3 text-[13px] ${bodyColor}`} data-id="element-198" data-mp="2ajze2s66dxnn">Available in {product.color}</p>
          <p className={`mt-1 text-[13px] leading-relaxed ${bodyColor}`} data-id="element-199" data-mp="26jpcdrpf1tel">{fulfillment.shippingLabel} · {fulfillment.dispatch}</p>
        </div>
      </div>

      <div className="relative flex min-w-0 justify-center md:justify-end" data-id="element-200" data-mp="1wjevnx46a3uo">
          <figure data-hero-art className="relative h-[210px] w-[280px] max-w-full md:h-[390px] md:w-[380px] lg:h-[510px] lg:w-[480px] xl:w-[500px]" data-id="element-201" data-mp="c1wa1kvu4llw">
            <span aria-hidden="true" className={`absolute bottom-[6%] left-[20%] h-3 w-[62%] rounded-[50%] blur-md md:h-5 ${isDark ? 'bg-black/40' : 'bg-ink/20'}`} data-id="element-202" data-mp="gzpdw79o13j0" />
            <img src={productImages.hero.src} alt={productImages.hero.alt} width={productImages.hero.nativeWidth} className="relative z-10 block h-full w-full object-contain" style={{
            filter: 'drop-shadow(0 16px 14px rgba(25, 27, 25, 0.18))'
          }} data-id="element-203" data-mp="q0dqqynboxub" />
            <figcaption className="sr-only" data-id="element-204" data-mp="2a027i3y5h4h">
              Shown in White, the launch color.
            </figcaption>
          </figure>
      </div>
      </div>
    </section>;
}